var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('prevent')
        ko.components.register('prevent', {
            viewModel: function (params) {
                var $this = this;
                var msg = common.urlSearch(location.href)["msg"];
                var entitlementId = common.urlSearch(location.href)["entitlementId"];
                $this.mag = decodeURIComponent(msg?msg:"禁止访问");
                $this.apply = function(){
                    var response = common.fetch("/auth/workflow/appAccessApply", {
                        method: "POST",
                        data: JSON.stringify({entitlementId:entitlementId}),
                    });
                    if(response.success){
                        common.message("success","申请成功,等待审核！");
                        common.redirectTo("/#/");
                    }
                }
                
            },
            template: require("./prevent.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/prevent/Prevent.js
// module id = 148
// module chunks = 0